






























import Vue from 'vue'
import { putFile } from '@/api/api'
import {
  FileServiceProxy,
  TransferDirectoryFileServiceProxy
} from '@/service-proxies/app-v2/dnc.service-proxies'

const fileservice = new FileServiceProxy()
const tdfsp = new TransferDirectoryFileServiceProxy()

import {
  ROfOssFile,
  ServiceProxy as ResourceServiceProxy
} from '@/service-proxies/app-v2/resource.service-proxies'
import dayjs from 'dayjs'
const resourceService = new ResourceServiceProxy()

export default Vue.extend({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    parentid: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      fileList: [],
      loading: false,
      submitData: []
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.fileList = []
          this.submitData = []
        }
      },
      immediate: true
    }
  },
  methods: {
    beforeUpload(file: any) {
      const isGt20M = file.size / 1024 / 1024 > 20
      if (isGt20M) {
        this.$message.error(this.$t('page_my_document_notsupport'))
        return false
      }

      if (this.fileList.map((f) => f.name).includes(file.name)) {
        this.$message.error(file.name + ' ' + this.$t('file_is_exist'))
        return false
      }
    },
    handleOk(req): void {
      let uploadFile = req.file
      this.fileList.push(uploadFile)
      uploadFile.status = 'uploading'

      if (!this.fileList) {
        this.$message.success(this.$t('page_my_document_select'))
      }

      const formData = new FormData()
      formData.append('file', uploadFile)

      putFile(
        formData,
        (res) => {
          uploadFile.status = 'done'

          let fileName = res.data.data.name
          resourceService.statFileUsingGET(fileName).then((statRes: ROfOssFile) => {
            let ossFile = statRes.data
            this.submitData.push({ ossFile, uploadFile })
          })
        },
        (err: any) => {
          uploadFile.status = 'error'
        }
      ).finally(() => {
        this.$forceUpdate()
      })
    },
    handleRemove(info: any) {
      let delIndex = this.fileList.findIndex((file) => file.uid === info.uid)
      this.fileList.splice(delIndex, 1)

      let i = this.submitData.findIndex((el) => el.uploadFile.uid === info.uid)
      this.submitData.splice(i, 1)
    },
    save() {
      this.loading = true
      let params = this.addType(this.submitData)
      tdfsp.save(params).then(() => {
        this.loading = false
        this.$emit('closeUpload', true)
      })
    },
    addType(value) {
      const node = value.map((res) => {
        let suffix = ''
        const index = res.uploadFile.name.indexOf('.')
        if (index != -1) {
          suffix = res.uploadFile.name.substring(index + 1)
        }
        const aa = {
          contentLength: res.ossFile.length,
          contentMd5: res.ossFile.hash,
          contentType: res.ossFile.contentType,
          fileType: 1,
          filename: res.uploadFile.name,
          lastModified: dayjs().valueOf(),
          objectKey: res.ossFile.name,
          originalFilename: res.uploadFile.name,
          suffix: suffix,
          transferDirectoryId: this.parentid,
          fileSource: 0
        }
        return aa
      })
      return node
    },
    handleCancel() {
      this.loading = false
      this.$emit('closeUpload', false)
    }
  }
})
